import { FunctionComponent, PropsWithChildren } from 'react';
import { useTimelineItemContext } from './TimelineItemContext';

export interface TimelineItemContentRightProps extends PropsWithChildren {}

export const TimelineItemContentRight: FunctionComponent<TimelineItemContentRightProps> = ({ children }) => {
  const { isFirst, isLast } = useTimelineItemContext();
  return <div className={`flex flex-1 flex-col items-start   ${isFirst ? 'pt-2' : 'pt-6'}`}>{children}</div>;
};
